import React, { useEffect, useState } from 'react';
import Facility from "../component/Facility";
import {Link} from 'react-router-dom';
import VisaType from "../component/VisaType";
import VisaInstruction from "../component/VisaInstruction";
import OurSuccess from "../component/OurSuccess";
import Partner from "../component/Partner";
import BLogCardHome from "../component/BlogCardHome";
import Testimonial from "../component/Testimonial";
import FaqHome from "../component/FaqHome";
import FreeConsultation from "../component/FreeConsultation";
import SliderWrapper from "../component/SliderWrapper";
import axios from "axios";
import SuccessTimelineSection from "../component/SuccessTimelineSection";
import RecruitmentCallCenter from "../component/RecruitmentCallCenter";
import WhyHire from "../component/WhyHire";
import SectionPage from "../component/SectionPage";
import RecruitmentProcess from "../component/RecruitmentProcess";
import WhyPartner from "../component/WhyPartner";
import {Helmet} from "react-helmet-async";

const Home = () => {
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        const lastShown = localStorage.getItem('welcomeModalShown');
        const THIRTY_MINUTES = 30 * 60 * 1000;

        if (!lastShown || Date.now() - parseInt(lastShown) > THIRTY_MINUTES) {
            setShowModal(true);
            localStorage.setItem('welcomeModalShown', Date.now().toString());
        }
    }, []);
    useEffect(() => {
        if (showModal) {
            const timer = setTimeout(() => {
                setShowModal(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [showModal]);
    const handleClose = () => {
        setShowModal(false);
    };

    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    /*const [popup, setPopup] = useState([]);

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_BLOGS;

        const cachedBlogs = localStorage.getItem("blogs");
        const cacheTimestamp = localStorage.getItem("blogsTimestamp");
        const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes

        if (cachedBlogs && cacheTimestamp && (Date.now() - cacheTimestamp < cacheExpiryTime)) {
            // ✅ Use cached data
            setBlogs(JSON.parse(cachedBlogs));
        } else {
            // ❌ Fetch new data from API
            axios.get(`${apiBaseUrl}${Url}`)
                .then(response => {
                    setBlogs(response.data);
                    localStorage.setItem("blogs", JSON.stringify(response.data));
                    localStorage.setItem("blogsTimestamp", Date.now());
                })
                .catch(error => console.error("Error fetching API", error));
        }
    }, []);*/
    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | Trusted Overseas Recruitment Agency in Bangladesh</title>

                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>

                <link rel="canonical" href="https://tarifoverseasltd.com/" />
            </Helmet>
            <main>
                {/*{showModal && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        <button style={styles.closeButton} onClick={handleClose}>
                            ✕
                        </button>
                        <img
                            src="image.jpg"
                            alt="Welcome"
                            style={styles.image}
                            onError={(e) =>
                                (e.target.src =
                                    'https://via.placeholder.com/200x150.png?text=Fallback')
                            }
                        />
                    </div>
                </div>
            )}*/}
                {/*<HomeSliderSection />*/}
                {/*<HeroSlider />*/}
                <SliderWrapper image={"banner.webp"} />
                <FreeConsultation />
                <WhyHire />
                <WhyPartner />
                <VisaType />
                <SectionPage />
                <OurSuccess />
                <Testimonial />
                <RecruitmentProcess />
                <SuccessTimelineSection />
                <RecruitmentCallCenter />
                <FaqHome />
                <BLogCardHome />
                {/*<Partner />*/}
            </main>
        </>

);
};

// 🎨 Styles
const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
    },
    modal: {
        position: 'relative',
        width: '500px',
        backgroundColor: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
        overflow: 'hidden',
    },
    image: {
        width: '100%',
        height: 'auto',
        display: 'block',
    },
    closeButton: {
        position: 'absolute',
        top: '8px',
        right: '10px',
        background: '#ff4d4f',
        color: 'white',
        border: 'none',
        borderRadius: '50%',
        width: '28px',
        height: '28px',
        fontSize: '16px',
        cursor: 'pointer',
        zIndex: 1,
    },
};


export default Home;